export default __webpack_public_path__ + "static/media/green_line.789efb8d.svg";